module.exports = __webpack_public_path__ + "img/portrait-063.6af0a3b1.jpg";